"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
const heroImages = [{
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/heavy_duty_trucks_fleet_overview.png",
  alt: "Heavy duty trucks fleet overview"
}, {
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/mining_dump_trucks_in_action.png",
  alt: "Mining dump trucks in action"
}, {
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/flatbed_transport_convoy.png",
  alt: "Flatbed transport convoy"
}, {
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/articulated_haulers_construction_site.png",
  alt: "Articulated haulers at construction site"
}];
export default function YourFleetAwaits() {
  const heroRef = useRef<HTMLDivElement>(null);
  const bgRef = useRef<HTMLDivElement>(null);
  const overlayRef = useRef<HTMLDivElement>(null);
  const [isHoveringCTA, setIsHoveringCTA] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageTransition, setImageTransition] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setImageTransition(true);
      setTimeout(() => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % heroImages.length);
        setImageTransition(false);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const bgElement = bgRef.current;
    const overlayElement = overlayRef.current;
    if (!bgElement || !overlayElement) return;
    bgElement.style.transform = "scale(1.03)";
    setTimeout(() => {
      bgElement.style.transform = "scale(1)";
    }, 100);
    overlayElement.style.transform = "translateY(0)";
    const handleScroll = () => {
      if (isHoveringCTA) return;
      const scrollY = window.scrollY;
      const heroHeight = heroRef.current?.offsetHeight || 0;
      if (scrollY < heroHeight) {
        const parallaxOffset = scrollY * 0.5;
        bgElement.style.transform = `translateY(${parallaxOffset}px) scale(1)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHoveringCTA]);
  const handleDotClick = (index: number) => {
    setImageTransition(true);
    setTimeout(() => {
      setCurrentImageIndex(index);
      setImageTransition(false);
    }, 300);
  };

  //  baja a "Explora nuestros modelos de camiones"
  const handleScrollToTrucks = () => {
    const target = document.getElementById("modelos-camiones") || document.querySelector('[data-section="modelos-camiones"]') || document.querySelector('h2, h1');
    const el = target as HTMLElement | null;
    if (!el) return;
    const headerOffset = 80; // ajusta si tu header fijo es distinto
    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementPosition - headerOffset,
      behavior: "smooth"
    });
  };
  return <section ref={heroRef} className="relative h-screen w-full overflow-hidden bg-dark-background">
      <div ref={bgRef} className="absolute inset-0 bg-cover bg-center transition-all duration-[2000ms] ease-out" style={{
      transformOrigin: "center center",
      backgroundImage: `url(${heroImages[currentImageIndex].url})`,
      opacity: imageTransition ? 0.7 : 1
    }} />

      <div className="absolute inset-0 bg-dark-background/60" />

      <div className="relative z-10 flex h-full items-center justify-center px-4">
        <div ref={overlayRef} className="glass-effect max-w-2xl px-8 py-12 text-center shadow-strong backdrop-blur-md transition-transform duration-700 ease-out md:px-12 md:py-16" style={{
        transform: "translateY(2rem)"
      }}>
          <h1 className="mb-6 font-display text-4xl font-bold leading-tight text-black md:text-5xl lg:text-6xl">
            Su flota le espera
          </h1>
          <p className="mb-8 text-lg text-black/90 md:text-xl">
            Soluciones integrales para la construcción y la minería. Disponemos de camiones, maquinaria pesada y equipos de alta calidad para venta o alquiler.
          </p>

          <div onMouseEnter={() => setIsHoveringCTA(true)} onMouseLeave={() => setIsHoveringCTA(false)}>
            <Button onClick={handleScrollToTrucks} size="lg" className="group bg-accent text-foreground shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105 hover:bg-accent-hover hover:shadow-strong focus-ring">
              Explora Nuestra Flota
              <ArrowDown className="transition-transform duration-[var(--duration-medium)] group-hover:translate-y-1" />
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-20 flex -translate-x-1/2 gap-3">
        {heroImages.map((_, index) => <Button key={index} variant="ghost" size="icon" onClick={() => handleDotClick(index)} className={`h-3 w-3 rounded-full p-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${currentImageIndex === index ? "w-8 bg-accent shadow-medium hover:bg-accent-hover" : "bg-background/60 hover:bg-background/80"}`} aria-label={`Go to image ${index + 1}`} />)}
      </div>
    </section>;
}